<template lang="pug">
  div.vkb_nak.vkb_nak_vkb.vkb_nak_internship
    .small-12.columns.wrapper-spacing
      #top-nav.extended-progress.extended-progress-standard.extended-progress-tabs-6
        ul: li(
          v-for="step in steps"
          :class="step.id === current_step ? 'active' : 'inactive'"
          :key="step.id"
          @click="onSelectStep(step.id)"
        )
          span.extended-progress-numb {{ step.id }}
          span.extended-progress-desc {{ step.text }}

      .row.wrapper-spacing(v-if="current_step === 1")
        .columns.small-12.medium-12.large-12
          h3 Haftpflicht- und Unfallschutz für Betriebspraktika<br>Haftpflichtschutz für Hochschulsemester

          #internship-input.row.mt-5
            .large-4.medium-12.small-12.columns.form-break-spacing
              h4.feedback
                span.feedback-before(:class="internship.date_from && internship.date_to && 'validated'")
                span Praktikum

            .large-4.medium-7.small-12.columns
              label Für welche Art Praktikum wollen Sie sich absichern?

            .large-4.medium-5.small-12.columns
              .select-wrapper
                n-custom-select(
                  v-model="internship.type"
                  :items="internship_types"
                  :value-field="`value`"
                  :text-field="`text`"
                  @input="loadCalcResult"
                )

          template(v-if="internship.type")
            .row.mt-8
              .large-4.large-offset-4.medium-7.small-12.columns
                label {{ internship.type === 's' ? 'Semesterbeginn' : 'Praktikumsbeginn' }} *

              .large-4.medium-5.small-12.columns
                vkb-date-picker.right-aligned(
                  v-model="internship.date_from"
                  :ref="`date-from`"
                  :format="`DD.MM.YYYY`"
                  :max-date="max_date_from"
                  :min-date="min_date_from"
                  :readonly="!internship.type"
                  @input="loadCalcResult"
                  @show="closeOtherPicker('date-to')"
                )

            .row.mt-4
              .large-4.large-offset-4.medium-7.small-12.columns
                label {{ internship.type === 's' ? 'Semesterende' : 'Praktikumsende' }} *

              .large-4.medium-5.small-12.columns
                vkb-date-picker.right-aligned(
                  v-model="internship.date_to"
                  :ref="`date-to`"
                  :format="`DD.MM.YYYY`"
                  :max-date="max_date"
                  :min-date="min_date_to"
                  :readonly="!internship.type"
                  @input="loadCalcResult"
                  @show="closeOtherPicker('date-from')"
                )

            .row.tk-vkb-bg1.mt-6(v-if="calc_result")
              .large-8.large-offset-4.medium-12.small-12.columns.my-4
                .highlight(v-if="internship.type === 's' && calc_result.month_error")
                  .row.mt-3
                    .small-12.columns
                      p Online kann nur eine Semesterlänge von maximal 7 Monaten versichert werden. Bitte korrigieren Sie Semesterbeginn oder –ende. Alternativ können Sie ein individuelles Angebot bei uns anfragen.

                    .small-12.columns.text-right
                      a.button.call-to-action.mt-3(@click.stop="onContactClick")
                        i.fo.fo-paper
                        span Angebot anfordern

                .highlight(v-else)
                  .row
                    .large-6.medium-7.small-12.columns: label Vertragslaufzeit
                    .large-6.medium-5.small-12.columns {{ contract_term }}

                  .row.mt-2(v-if="internship.type === 'p'")
                    .large-6.large-offset-6.medium-5.medium-offset-7.small-12.columns {{ contract_weeks }}

                  .row.mt-4
                    .large-6.medium-7.small-12.columns: h4 Gesamtbeitrag
                    .large-6.medium-5.small-12.columns: h4 {{ calc_value }} Euro

            .row.mt-3
              .large-4.large-offset-4.medium-6.small-12.columns
                label * Pflichtangaben

              .large-4.medium-6.small-12.columns(v-if="internship.type === 'p' || !calc_result || calc_result.number_months <= 6")
                a.button.call-to-action.block(
                  :class="!calc_result && 'disabled'"
                  @click.stop="onNextStep"
                )
                  span Weiter
                  i.fo.fo-arrow-right

      .row.wrapper-spacing(v-if="current_step === 2")
        .columns.small-12.medium-12.large-12
          h3 {{ title }}

          hr.mt-6.mb-6

          #policyholder-input.row
            .large-4.medium-12.small-12.columns.form-break-spacing
              h4.feedback
                span.feedback-before(:class="!$v.policyholder.$invalid && 'validated'")
                span Daten Versicherungsnehmer

            .large-3.medium-4.small-12.columns
              label.pt-2 Anrede *

            .large-4.medium-7.small-10.columns
              n-radio(
                v-model="policyholder.gender"
                :id="`gender`"
                :options="genders"
                :error="getErrorMessage('policyholder', 'gender')"
              )

            .large-1.medium-1.small-2.columns
              span.feedback-after(:class="!$v.policyholder.gender.$invalid && 'validated'")

          template(v-for="item in policyholder_inputs")
            .row.mt-3(v-if="!item.hide" :key="item.id")
              .large-3.large-offset-4.medium-4.small-12.columns
                label.mt-2.pb-0 {{ item.text }} {{ item.required ? '*' : '' }}

              .large-4.medium-7.small-10.columns
                vkb-date-picker(
                  v-if="item.id === 'birthday'"
                  v-model="policyholder[item.id]"
                  :format="`DD.MM.YYYY`"
                  :max-date="max_date"
                  :default-date="default_birthday"
                  :error="getErrorMessage('policyholder', 'birthday')"
                )

                n-text(
                  v-else
                  v-model="policyholder[item.id]"
                  :error="getErrorMessage('policyholder', item.id)"
                )

              .large-1.medium-1.small-2.columns(v-if="item.required")
                span.feedback-after(:class="!$v.policyholder[item.id].$invalid && 'validated'")

          hr.mt-3.mb-3

          #company-input.row.mt-4
            .large-4.medium-12.small-12.columns.form-break-spacing
              h4.feedback
                span.feedback-before(:class="!$v.company.$invalid && 'validated'")
                span {{ internship.type === 'p' ? 'Daten Betrieb' : 'Daten Hochschule in Bayern' }}

            .large-3.medium-4.small-12.columns
              label.pt-2 Name *

            .large-4.medium-7.small-10.columns
              n-text(v-model="company.b_name" :error="getErrorMessage('company', 'b_name')")

            .large-1.medium-1.small-2.columns
              span.feedback-after(:class="!$v.company.b_name.$invalid && 'validated'")

          template(v-for="item in company_inputs")
            .row.mt-3(v-if="!item.hide" :key="`company-${ item.id }`")
              .large-3.large-offset-4.medium-4.small-12.columns
                label.mt-2.pb-0 {{ item.text }} {{ item.required ? '*' : '' }}

              .large-4.medium-7.small-10.columns
                n-text(v-model="company[item.id]" :error="getErrorMessage('company', item.id)")

              .large-1.medium-1.small-2.columns(v-if="item.required")
                span.feedback-after(:class="!$v.company[item.id].$invalid && 'validated'")

          .row.mt-3
            .large-4.large-offset-4.medium-6.small-12.columns
              label * Pflichtangaben

          .row.mt-5
            .large-6.medium-6.small-6.columns
              a.button.block(@click="onPrevStep")
                i.fo.fo-arrow-left
                span Zurück

            .large-6.medium-6.small-6.columns
              a.button.call-to-action.block(@click.stop="onNextStep")
                span Weiter
                i.fo.fo-arrow-right

      .row.wrapper-spacing(v-if="current_step === 3")
        .columns.small-12.medium-12.large-8.large-offset-1
          label.mt-3 Bitte lesen Sie diese Seite noch einmal aufmerksam durch und prüfen Ihre Angaben.

          h4.mt-6 Daten Versicherungsnehmer
            a.button.button-link.button-light.pl-2(@click="onSelectStep(2, '#policyholder-input')")
              i.fa.fa-pencil

          .row.mt-2(v-for="item in policyholder_inputs" :key="item.id")
            .large-8.medium-8.small-12.columns
              label {{ item.text }}
            .large-4.medium-4.small-12.columns
              span(v-if="item.id === 'gender'") {{ policyholder.gender === 'm' ? 'Herr' : 'Frau' }}
              span(v-else) {{ policyholder[item.id] }}

        .columns.small-12.medium-12.large-8.large-offset-1
          h4.mt-6 {{ internship.type === 'p' ? 'Daten Betrieb' : 'Daten Hochschule in Bayern' }}
            a.button.button-link.button-light.pl-2(@click="onSelectStep(2, '#company-input')")
              i.fa.fa-pencil

          .row.mt-2
            .large-8.medium-8.small-12.columns
              label Name
            .large-4.medium-4.small-12.columns
              span {{ company.b_name }}

          .row.mt-2(v-for="item in company_inputs" :key="item.id")
            .large-8.medium-8.small-12.columns
              label {{ item.text }}
            .large-4.medium-4.small-12.columns
              span {{ company[item.id] }}

        .columns.small-12.medium-12.large-8.large-offset-1
          h4.mt-6 Versicherungsschutz
            a.button.button-link.button-light.pl-2(@click="onSelectStep(1, '#internship-input')")
              i.fa.fa-pencil

          label {{ title }}

          .row.tk-vkb-bg1.mt-3
            .large-12.medium-12.small-12.columns
              .highlight
                .row
                  .large-6.medium-7.small-12.columns: label Vertragslaufzeit
                  .large-6.medium-5.small-12.columns {{ contract_term }}

                .row.mt-2(v-if="internship.type === 'p'")
                  .large-6.large-offset-6.medium-5.medium-offset-7.small-12.columns {{ contract_weeks }}

                .row.mt-4
                  .large-6.medium-7.small-12.columns: h4 Gesamtbeitrag
                  .large-6.medium-5.small-12.columns: h4 {{ calc_value }} Euro

          .row.tk-vkb-bg1.mt-6
            .large-12.medium-12.small-12.columns.wrapper-spacing
              .highlight(v-if="user_info")
                .mt-1 Nach Abschluss überweisen Sie bitte Ihren Versicherungsbeitrag.

                .row.mt-4
                  .large-4.medium-5.small-12.columns: label Zahlungsempfänger:
                  .large-8.medium-7.small-12.columns {{ user_info.zahlungsempfaenger }}

                .row
                  .large-4.medium-5.small-12.columns: label Bankinstitut:
                  .large-8.medium-7.small-12.columns {{ user_info.bank }}

                .row
                  .large-4.medium-5.small-12.columns: label IBAN:
                  .large-8.medium-7.small-12.columns {{ user_info.iban }}

                .row
                  .large-4.medium-5.small-12.columns: label BIC:
                  .large-8.medium-7.small-12.columns {{ user_info.bic }}

                .row
                  .large-4.medium-5.small-12.columns: label Verwendungszweck:
                  .large-8.medium-7.small-12.columns
                    p {{ user_info.vzweck_1 }}
                    p {{ internship.type === 'p' ? user_info.vzweck_praktika : user_info.vzweck_semester }}

                // .mt-3 Zahlungsempfänger und Kontoverbindung entnehmen Sie bitte diesem Dokument: <a>DOWNLOAD</a>
                .mt-3 Nehmen Sie einen Ausdruck der Überweisung oder Ihren entsprechenden Kontoauszug zu Ihren Unterlagen (dient als Nachweis über die Versicherung im Schadenfall).

          .row.mt-5
            .large-6.medium-6.small-6.columns
              a.button.block(@click="onPrevStep")
                i.fo.fo-arrow-left
                span Zurück

            .large-6.medium-6.small-6.columns
              a.button.call-to-action.block(@click.stop="onNextStep")
                span Weiter
                i.fo.fo-arrow-right

      .row.wrapper-spacing(v-if="current_step === 4")
        .columns.small-12.medium-12.large-12
          h3 {{ title }}

          .row.mt-6
            .large-6.medium-6.small-12.columns
              h4 Informationen rund um Ihren Versicherungsschutz<br>Nehmen Sie Ihr Recht auf gute Information in Anspruch. Mit Ihrem Einverständnis informieren wir Sie weiterhin zeitnah und vor allem umfassend und gezielt zu Themen, die für Sie persönlich relevant sind.

              .mt-2
                n-checkbox(
                  v-model="agreement.confirm_risiko"
                  id="confirm_risiko"
                  label="Ich willige ein, dass der Versicherer im erforderlichen Umfang Daten, die sich aus den Antragsunterlagen oder der Vertragsdurchführung ergeben, an Rückversicherer zur Beurteilung des Risikos und zur Abwicklung der Rückversicherung sowie zur Beurteilung des Risikos und der Ansprüche an andere Versicherer und/oder an den Gesamtverband der Deutschen Versicherungswirtschaft e.V. und den Verband öffentlicher Versicherer zur Weitergabe dieser Daten an andere Versicherer übermittelt. Diese Einwilligung gilt auch für entsprechende Prüfungen bei anderweitig beantragten Versicherungsverträgen und bei künftigen Anträgen. Ich willige ferner ein, dass die zur Versicherungsgruppe Versicherungskammer Bayern gehörenden Unternehmen und die ÖRAG Rechtsschutzversicherungs-AG meine allgemeinen Antrags-, Vertrags- und Leistungsdaten in gemeinsamen Datensammlungen führen und an den für mich zuständigen Versicherungskammer Bayern sowie an Unternehmen, die mit Serviceleistungen beauftragt sind, weitergeben, soweit dies der ordnungsgemäßen Durchführung meiner Versicherungsangelegenheiten dient. (*)"
                )

            .large-6.medium-6.small-12.columns
              .mt-2
                n-checkbox(
                  v-model="agreement.confirm_sonstig"
                  id="confirm_sonstig"
                  label="Ohne Einfluss auf den Vertrag und jederzeit widerrufbar willige ich weiter ein, dass die Versicherungskammer Bayern und deren Berater meine allgemeinen Antrags-, Vertrags- und Leistungsdaten darüber hinaus für die Beratung und Betreuung auch in sonstigen Finanzdienstleistungen nutzen darf."
                )

              h4.mt-4 Information zum Widerrufsrecht

              .mt-2
                n-checkbox(
                  v-model="agreement.confirm_widerrufsrecht"
                  id="confirm_widerrufsrecht"
                  label="Ich bin einverstanden, dass der beantragte Versicherungsschutz schon vor Ablauf der Widerrufsfrist gewährt wird,soweit der Versicherungsbeginn bereits vor Ablauf der Widerrufsfrist liegt. Im Fall des Widerrufs wird nur der Beitrag berechnet, der auf die Zeit vor Zugang des Widerrufs entfällt. Der Beitrag wird unverzüglich nach dem vereinbarten Versicherungsbeginn fällig. (*)"
                )

              h4.mt-4 Beratungsfreiheit

              .mt-2
                n-checkbox(
                  v-model="agreement.confirm_beratungsfreiheit"
                  id="confirm_beratungsfreiheit"
                  label="Bei dieser Versicherung handelt es sich um eine genormte Versicherung mit kurzer Vertragsbindung, die Versicherungsantrag und Versicherungsschein zum schnellen und unkomplizierten Vertragsabschluss kombiniert und deren Inhalt keiner Beratung mit entsprechender Dokumentation bedarf. Ich nehme das zur Kenntnis und bestätige die Kenntnisnahme. (*)"
                )
          .row.mt-2.small-12.columns
            h4.mt-1.font-sp Die Bayerischer Versicherungsverband Versicherungsaktiengesellschaft wird Ihre Mailadresse nach erfolgtem Abschluss der Zusatzversicherung auch nutzen, um Ihnen Informationen zu weiteren Zusatzversicherungen zu schicken, die Ihren Versicherungsschutz ergänzen würden und die Ihre finanzielle Absicherung im Haftpflicht- und Unfallfall weiter verbessern könnten. Rechtsgrundlage ist das berechtigte Interesse der Bayerischer Versicherungsverband Versicherungsaktiengesellschaft an der werblichen Ansprache ihrer Kunden zu ähnlichen Angeboten (Art. 6 Abs. 1 lit. f DSGVO).
            h4.mt-1.font-sp Widerspruchsrecht: Sie haben das Recht, der E-Mail-Werbung und der damit verbundenen Datenverarbeitung jederzeit in beliebiger Form und ohne Angabe von Gründen direkt in der E-Mail zu widersprechen. Hierfür werden keine anderen Kosten als die nach den Basistarifen entstehen.
            h4.mt-1.font-sp Weitere Hinweise zum Datenschutz finden Sie auf Datenschutz | VKB.
          .row.tk-vkb-bg1
            .large-12.medium-12.small-12.columns.wrapper-spacing
              .highlight
                span Bei der Übertragung und Verarbeitung Ihrer Daten gelten unsere
                a.ml-1(target="blank" href="https://www.vkb.de/content/ueber-uns/unternehmen/datenschutz-compliance/datenschutz/") Datenschutzrichtlinien

          .row.mt-2
            .large-12.medium-12.small-12.columns
              label.position-relative
                a: i.fo.fo-exclamation.info-tooltip(@click="show_hint = !show_hint")
                  span.hint(:class="show_hint && 'open'" @mouseout="show_hint = false") Um diese Datei zu öffnen, benötigen Sie den kostenlosen Adobe Reader. Falls der Adobe Reader auf Ihrem Rechner noch nicht installiert sein sollte, können Sie ihn <a href="https://get.adobe.com/reader" target="blank">hier</a> herunterladen. (https://get.adobe.com/reader)
                span Bitte laden Sie erst die Produktinformationen / Versicherungsbedingungen herunter und speichern das PDF auf Ihrem Rechner.

            .large-12.medium-12.small-12.columns
              a.button.btn-spinner.mt-4(
                :class="(!downloadable || loading || document_id) && 'disabled'"
                @click="onDownloadTerms"
              )
                i.fo.fo-download.mr-2
                | Produktinformationen / Versicherungsbedingungen
                i.fa.fa-spinner.fa-spin.ml-1(v-if="loading")

              .mt-4
                n-checkbox(
                  v-model="confirm_download"
                  id="confirm_download"
                  label="Ich bestätige, dass ich die Unterlagen heruntergeladen habe und mit deren Inhalt einverstanden bin. (*)"
                  :disabled="!document_id"
                )

          .row.d-flex.mt-5
            .small-12.columns
              label * Pflichtangaben

            .large-6.medium-6.small-12.columns
              a.button.block(v-if="!document_id" @click="onPrevStep")
                i.fo.fo-arrow-left
                span Zurück

            .large-6.medium-6.small-12.columns
              a.button.call-to-action.block(
                :class="(!document_id || !confirm_download) && 'disabled'"
                @click.stop="onNextStep"
              )
                span Kostenpflichtig abschließen
                i.fo.fo-arrow-right

      .row.wrapper-spacing(v-if="current_step === 5")
        .columns.small-12.medium-12.large-12
          h3 {{ title }}

          .row.mt-6
            .large-8.large-offset-1.medium-12.small-12.columns
              p Vielen Dank, dass Sie sich für die Versicherungskammer Bayern entschieden haben!
              p Ihr Antrags-/Versicherungsdokument wurde erstellt.

              h4.text-underline.mt-4 Was ist jetzt noch zu tun?

              template(v-if="internship.type === 'p'")
                p Wir haben entsprechend Ihren Angaben ein PDF-Dokument erstellt. Bitte laden Sie das Dokument auf Ihren Rechner, speichern Sie es oder drucken es aus und überweisen mit den dort angegebenen Zahlungsinformationen den Versicherungsbeitrag auf das angegebene Konto.
                p.mt-3 Bitte <span class="text-underline">senden</span> Sie eine Kopie der Seiten 2 bis 4 des PDF-Dokuments sowie einen Zahlungsbeleg an:
                p Versicherungskammer Bayern, 80530 München oder per Mail an: <a href="mailto:haftoebetrieb@vkb.de">haftoebetrieb@vkb.de</a>
                p.mt-3 Der Versicherungsschutz beginnt ab Praktikumsbeginn, frühestens ein Tag nach der Beitragsüberweisung.

              template(v-else)
                p Wir haben entsprechend Ihren Angaben ein PDF-Dokument erstellt. Bitte laden Sie das Dokument auf Ihren Rechner, speichern Sie es oder drucken es aus und überweisen mit den dort angegebenen Zahlungsinformationen den Versicherungsbeitrag auf das angegebene Konto.
                p.mt-3 Bitte <span class="text-underline">senden</span> Sie eine Kopie der Seiten 1 und 2 des PDF-Dokuments sowie einen Zahlungsbeleg an:
                p Versicherungskammer Bayern, 80530 München oder per Mail an: <a href="mailto:haftoebetrieb@vkb.de">haftoebetrieb@vkb.de</a>
                p.mt-3 Der Versicherungsschutz beginnt ab Praktikumsbeginn, frühestens ein Tag nach der Beitragsüberweisung.

              a.button.call-to-action.btn-spinner.mt-4(:class="loading && 'disabled'" @click="onDownloadInsurance")
                span Antrag / Versicherungsschein erneut herunterladen
                i.fa.fa-spinner.fa-spin.ml-1(v-if="loading")

          .row.tk-vkb-bg1.mt-4
            .large-8.large-offset-1.medium-12.small-12.columns
              .highlight
                .row
                  .large-6.medium-7.small-12.columns: label Vertragslaufzeit
                  .large-6.medium-5.small-12.columns {{ contract_term }}

                .row.mt-2(v-if="internship.type === 'p'")
                  .large-6.large-offset-6.medium-5.medium-offset-7.small-12.columns {{ contract_weeks }}

                .row.mt-4
                  .large-6.medium-7.small-12.columns: h4 Gesamtbeitrag
                  .large-6.medium-5.small-12.columns: h4 {{ calc_value }} Euro

          .row.mt-4
            .large-8.large-offset-1.medium-12.small-12.columns
              a.button.block(@click="() => onResetStep()")
                span Weitere Praktikantenversicherung abschließen

          .row.mt-8
            .large-8.large-offset-1.medium-12.small-12.columns
              h4 Sie haben noch Fragen?
              p.mt-2 Rufen Sie uns an oder schicken Sie uns eine Mail. Wir freuen uns auf Sie!

              h4.mt-4
                i.icon-contact.fo.fo-phone.mr-2
                | (089) 2160-3384

              h4
                i.icon-contact.fo.fo-mail.mr-2
                | <a href="mailto:haftoebetrieb@vkb.de">haftoebetrieb@vkb.de</a>

</template>

<script>
import logic from './logic.js';

export default {
  name: 'internship_vkb',

  mixins: [
    logic
  ],

  created() {
    window.addEventListener('scroll', this.onScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
};
</script>

<style>
  .font-sp {
    font-size:12px;
    line-height: normal;
  }
</style>



// WEBPACK FOOTER //
// src/apps/internship/vkb.vue